import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import getConfig from 'next/config';
import { getCookie } from '../../../utils/cookie';
import { mapApiException, reportApiException } from './interceptors';

const { publicRuntimeConfig } = getConfig();

function apiConfigFactory(): AxiosRequestConfig {
  return {
    baseURL: publicRuntimeConfig.bffApiBaseUrl,
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      Accept: 'application/json',
      'Client-Token': 'RNKqxPr4Oi06JypV8qIwjAtHv6gQaXTa',
    },
    timeout: 60000, // calenderが重いので多めに確保
    withCredentials: true,
  };
}

export function newAxiosInstance(
  session?: string,
  token?: string,
): AxiosInstance {
  const instance = axios.create(apiConfigFactory());
  instance.interceptors.request.use((request: AxiosRequestConfig) => {
    request.headers['X-Session'] = session || getCookie('cb') || '';
    request.headers['X-Access-Token'] = token || getCookie('token') || '';

    return request;
  });

  // TODO: secured-axios では 判定したlocaleを送信しているがこちらはしていない
  instance.interceptors.response.use(undefined, reportApiException);
  instance.interceptors.response.use(undefined, mapApiException);

  return instance;
}
